<template lang="pug">
  modal(@hide="$emit('hide')" width='500px' modal-class='u-bg-primary u-p3 u-overflow-visible')
    div(slot='content' class='u-px4')
      h3(class='u-fz-h2 u-mt0 u-center u-line-1 u-mb4')
        span(class='u-color-secondary') Reporta&nbsp;
        span(class='u-white') Aquí

      form(@submit.prevent='postForm')
        input-validate(
          v-model='form.dni', :rule='rules.dni' icon='card' placeholder='DNI', :validation='toggleValidate'
          wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
        input-validate(
          v-model='form.cellphone', :rule='rules.cellphone' icon='cellphone' placeholder='Celular o teléfono', :validation='toggleValidate'
          wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
        input-validate(
          v-model='form.title', :rule='rules.title' icon='message' placeholder='Título del reporte', :validation='toggleValidate'
          wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
        datepicker(
          :calendar-button='true' calendar-button-icon='u-icon calendar' placeholder='Fecha de reporte'
          language='es' class='c-input c-input--icon u-mb3' format='dd MMMM yyyy' v-model='currentDate')
        file-validate(type='file' @update='updateFile'
          :rule='rules.photo.extension' icon='photo' placeholder='Foto', :validation='toggleValidate'
          wrapper-class='c-input c-input--icon' class='u-mb3' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')
        input-validate(
          v-model='form.detail' type='textarea', :rule='rules.detail' placeholder='Detalles del reporte', :validation='toggleValidate'
          wrapper-class='c-input' class='u-mb3 u-12/12' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold')
        div(class='u-mb3')
          button(class='c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-py3', :disabled='isLoading') Enviar
</template>

<script>
  import Validator from 'validatorjs'
  import axios from 'axios'

  export default {
    data () {
      return {
        toggleValidate: false,
        formValidate: false,
        isLoading: false,
        currentDate: '',
        form: {
          dni: '',
          cellphone: '',
          title: '',
          date: '',
          detail: '',
          // recaptcha: '',
          photo: {
            base64: '',
            extension: ''
          }
        },
        rules: {
          dni: 'required',
          title: 'required',
          date: 'required',
          detail: 'required',
          photo: {
            extension: 'required'
          },
          // recaptcha: 'required'
          cellphone: 'required|phone'
        }
      }
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          this.$emit('loading')
          axios.post(`${window.API_URL}/reports`, this.form)
            .then((response) => {
              this.isLoading = false
              this.$emit('loading')
              this.$emit('hide')
              this.$emit('success')
            })
            .catch(({response}) => {
              this.isLoading = false

              this.$emit('loading')
              this.$emit('error')
            })
        }
      },

      updateFile (image) {
        this.form.photo = image
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.toggleValidate = !this.toggleValidate
        this.formValidate = validation.passes()
      }
    },

    watch: {
      currentDate (val) {
        if (val) {
          this.form.date = val.format()
        } else {
          this.form.date = ''
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Reports/components/ModalReport.vue